import { render } from "./DropdownSelector.vue?vue&type=template&id=52b39f1a&scoped=true&ts=true&lang=html"
import script from "./DropdownSelector.vue?vue&type=script&lang=ts"
export * from "./DropdownSelector.vue?vue&type=script&lang=ts"

import "./DropdownSelector.vue?vue&type=style&index=0&id=52b39f1a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b39f1a"]])

export default __exports__